import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DocumentsState } from './documents.state';

export const selectDocumentsState = createFeatureSelector<DocumentsState>('adminDocuments');

export const selectAllDocuments = createSelector(
  selectDocumentsState,
  (state) => state.documents,
);

export const selectDocumentsLoading = createSelector(
  selectDocumentsState,
  (state) => state.loading,
);

export const selectDocumentsError = createSelector(
  selectDocumentsState,
  (state) => state.error,
);

export const selectDocumentsPagination = createSelector(
  selectDocumentsState,
  (state) => state.pagination,
);
